<template>
  <div class="facts">
    <div class="h1">
      <div>{{'factsTitle1' | localize}}&nbsp;</div>
      <div>{{'factsTitle2' | localize}}&nbsp;</div>
      <div>{{'factsTitle3' | localize}}&nbsp;</div>
    </div>
    <p>{{'factsDescription' | localize}}</p>

    <div class="facts__wrap">
      <div class="facts__item">
        <h2 class="text-bg-yellow">
          <img src="/img/mobile/facts/1.svg" alt /> {{'more' | localize}}
          <span>50</span>
        </h2>
        <p>{{'fact1' | localize}}</p>
      </div>
      <div class="facts__item">
        <h2 class="text-bg-purple">
          <img src="/img/mobile/facts/3.svg" alt /> {{'more' | localize}}
          <span>30</span>
        </h2>
        <p>{{'fact2' | localize}}</p>
      </div>
      <div class="facts__item">
        <h2 class="text-bg-blue">
          <img src="/img/mobile/facts/2.svg" alt />
          <span>{{year}}</span> {{'years' | localize}}
        </h2>
        <p>{{'fact3' | localize}}</p>
      </div>
      <div class="facts__item">
        <h2 class="text-bg-pink">
          <img src="/img/mobile/facts/4.svg" alt />
          <span>7</span> {{'contries' | localize}}
        </h2>
        <p>{{'fact4' | localize}}</p>
      </div>
    </div>

    <div class="facts__image">
      <img src="/img/mobile/facts/page2.svg" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "Facts",
  props: {},
  computed: {
    year() {
      return new Date().getUTCFullYear() - 2011;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.facts {
  @extend .text-center;
  position: relative;
  padding: $padding__block;

  &__wrap {
    @extend .flex__wrap, .flex__center__center;
  }

  &__image {
    margin-top: 45px;

    img {
      width: 100%;
      max-width: 480px;
    }
  }

  &__item {
    width: 290px;
    margin: 10px;

    img {
      margin-left: -40px;
    }

    h2 {
      padding-left: 10px;
      font-family: $font__secondary;
      font-size: 32px;
      font-weight: 800;

      span {
        font-family: $font__secondary;
        font-size: 75px;
      }
    }
  }
}
</style>
